import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaTable from 'Components/UI/Meta/MetaTable';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { metaOverrideSet } from './metaOverrideSet';

const styles = () => ({
  root: {},
  fields: {},
});


const MainPanel = ({
  className,
  classes,
}) => {
  const { pageContentCollection } = usePageContentContext();
  return (
    <MetaTable
      className={classNames(className, classes.root)}
      classes={{ cell: classes.root }}
      collection={pageContentCollection}
      RowProps={{
        metaOverrideSet,
      }}
    />
  );
};

MainPanel.defaultProps = {
  className: '',
};

MainPanel.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MainPanel);
